export default "__VITE_PUBLIC_ASSET__0bf215fc__"